<template>
  <div>
    <v-row>
      <v-col cols="12" class="d-flex justify-end">
        <v-btn color="primary" @click="navigateToCreateTask">Create Task</v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>

        <v-data-table
          :headers="headers"
          :items="tasks"
          :search="search"
          class="elevation-1 mt-4"
        >
          <template v-slot:item.status="{ item }">
            <v-switch
              :input-value="item._statusBoolean"
              :label="item._statusBoolean ? 'Active' : 'Inactive'"
              inset
              :disabled="item._updating"
              @change="toggleStatus(item)"
            ></v-switch>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import RestResource from "../../../services/dataServiceMobileV2";
const service = new RestResource();

export default {
  data() {
    return {
      tasks: [],
      search: "",
      headers: [
        { text: "Task ID", value: "_id" },
        { text: "Task Name", value: "name.en" },
        { text: "Points", value: "points" },
        { text: "Status", value: "status" },
      ],
    };
  },

  mounted() {
    this.getTasks();
  },

  methods: {
    async getTasks() {
      this.$setLoader();
      try {
        const r = await service.getTasks({ data: true });
        this.tasks = r.data.map((t) => ({
          ...t,
          _statusBoolean: t.status === "A", // for the switch
          _updating: false, // for disabling during update
        }));
      } catch (error) {
        console.error("Error fetching tasks:", error);
      } finally {
        this.$disableLoader();
      }
    },

    navigateToCreateTask() {
      this.$router.push({ name: "MobileV2TasksCreate" });
    },

    toggleStatus(task) {
      // Disable the switch during update
      task._updating = true;

      // Determine new status
      const newStatus = task._statusBoolean ? "I" : "A";

      service
        .updateTaskStatus({ taskId: task._id, status: newStatus })
        .then(() => {
          // Update the switch only after backend confirms
          task._statusBoolean = newStatus === "A";
          task.status = newStatus;
        })
        .catch((err) => {
          console.error("Failed to update status:", err);
          this.$toast.error("Failed to update task status");
        })
        .finally(() => {
          task._updating = false;
        });
    },
  },
};
</script>